import { render, staticRenderFns } from "./AddNewMessageUser.vue?vue&type=template&id=34b75838&"
import script from "./AddNewMessageUser.vue?vue&type=script&lang=js&"
export * from "./AddNewMessageUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports